/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserFeedback
 */
export interface UserFeedback {
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    feedbackId: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedback
     */
    type: UserFeedbackTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserFeedback
     */
    activityMinutes: number;
}


/**
 * @export
 */
export const UserFeedbackTypeEnum = {
    Rating: 'RATING',
    Scale: 'SCALE',
    Satisfaction: 'SATISFACTION'
} as const;
export type UserFeedbackTypeEnum = typeof UserFeedbackTypeEnum[keyof typeof UserFeedbackTypeEnum];


/**
 * Check if a given object implements the UserFeedback interface.
 */
export function instanceOfUserFeedback(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "feedbackId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "activityMinutes" in value;

    return isInstance;
}

export function UserFeedbackFromJSON(json: any): UserFeedback {
    return UserFeedbackFromJSONTyped(json, false);
}

export function UserFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFeedback {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feedbackId': json['feedbackId'],
        'title': json['title'],
        'type': json['type'],
        'activityMinutes': json['activityMinutes'],
    };
}

export function UserFeedbackToJSON(value?: UserFeedback | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feedbackId': value.feedbackId,
        'title': value.title,
        'type': value.type,
        'activityMinutes': value.activityMinutes,
    };
}

